import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { OpenFeature } from '@openfeature/angular-sdk';
import { AuthenticationRequestService } from '@services/auth/authentication.request.service';
import { AuthenticationService } from '@services/auth/authentication.service';
import { BusService } from '@services/bus.service';
import { EventsService } from '@services/events.service';

// import {GoogleAnalyticsEventsService} from '../../../services/tracking/google-analytics-events.service';
import { TrackingService } from '../../../services/tracking/tracking.service';

@Component({
  selector: 'app-account-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit, OnDestroy {
  loginErrors = undefined;
  showErrors = false;

  pending = false;
  justSignedUp = false;

  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.email, Validators.required]),
    password: new UntypedFormControl('', [Validators.required]),
  });

  constructor(
    private router: Router,
    private bus: BusService,
    private events: EventsService,
    private auth: AuthenticationRequestService,
    private authService: AuthenticationService,
    private trackingService: TrackingService,
    private route: ActivatedRoute,
  ) {}

  submitLogin() {
    const body = {
      email: this.loginForm.controls.email.value.trim(),
      password: this.loginForm.controls.password.value,
    };

    this.bus.publish(this.events.requested.action.authentication.login, body);
    this.pending = true;
  }

  loginSuccess() {
    this.authService.connectSockets();
    this.pending = false;

    this.authService.getCurrentUser.subscribe(async user => {
      await OpenFeature.setContext({ user: { email: user.email } });
      this.bus.publish(
        this.events.requested.action.tracking.track,
        {},
        'nav',
        'login',
        'login',
        -1,
        user._id,
        { email: user.email },
      );
    });

    this.router.navigate(['/']);
  }

  loginFailure(error) {
    this.pending = false;
    this.loginErrors = error.message;
    this.showErrors = true;
  }

  subscribe() {
    this.bus.subscribe(
      this.events.received.action.authentication.login.success,
      this.loginSuccess.bind(this),
    );
    this.bus.subscribe(
      this.events.received.action.authentication.login.failure,
      this.loginFailure.bind(this),
    );
  }

  unsubscribe() {
    this.bus.unsubscribe(
      this.events.received.action.authentication.login.success,
      this.loginSuccess.bind(this),
    );
    this.bus.unsubscribe(
      this.events.received.action.authentication.login.failure,
      this.loginFailure.bind(this),
    );
  }

  ngOnInit() {
    this.subscribe();
    this.route.queryParams.subscribe(q => {
      if (q.email) {
        this.loginForm.patchValue({ email: q.email });
      }

      if (q.justSignedUp) {
        this.justSignedUp = true;
      }
    });
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
}
